import { buildHeaders } from "./apiConfig";
import { SYNC_API_URL } from "../constants";

export async function triggerSyncJob(jobId, userEmail) {
  if (!jobId) throw new Error("jobId is required to trigger sync.");

  if (!SYNC_API_URL) {
    throw new Error("Sync API URL not configured. Set REACT_APP_SYNC_API_URL in your .env file.");
  }

  const url = SYNC_API_URL.replace(/\/$/, "");
  const payload = JSON.stringify({ job_id: jobId, user_email: userEmail });

  // eslint-disable-next-line no-console
  console.log(`[syncService] Triggering sync — jobId: ${jobId}, user: ${userEmail}`);

  let response;
  try {
    response = await fetch(url, {
      method: "POST",
      headers: buildHeaders(),
      body: payload,
    });
  } catch (networkErr) {
    throw new Error("Network error while triggering sync. Please check your connection.");
  }

  let json = {};
  try {
    json = await response.json();
  } catch {
    /* non-JSON body — fall through */
  }

  if (!response.ok) {
    const detail = json.error || json.message || `HTTP ${response.status}`;
    // eslint-disable-next-line no-console
    console.error(`[syncService] ❌ ${response.status} — ${detail}`);
    throw new Error(detail);
  }

  // eslint-disable-next-line no-console
  console.log("[syncService] ✅ Sync job triggered successfully.", json);
  return json;
}
